import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { UniversalCreateReducerMap, UniversalCreateRootStateKey } from '@ninety/mobile/platform/state';

import { UniversalCreateAnalyticsEffects } from './universal-create-analytics.effects';
import { UniversalCreateEffects } from './universal-create.effects';
import { UniversalCreateStore } from './universal-create.store';

@NgModule({
  imports: [
    StoreModule.forFeature(UniversalCreateRootStateKey, UniversalCreateReducerMap),
    EffectsModule.forFeature(UniversalCreateEffects, UniversalCreateAnalyticsEffects),
  ],
  providers: [UniversalCreateStore],
})
export class UniversalCreateStateModule {}
